import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
} from '@angular/core';
import type { IHeaderAngularComp } from 'ag-grid-angular';
import type {
  ColDef,
  HeaderValueGetterParams,
  IHeaderParams,
} from 'ag-grid-community';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./header-cell.component.scss'],
  templateUrl: './header-cell.component.html',
  standalone: false,
})
export class HeaderCellComponent implements IHeaderAngularComp {
  public title: string;
  public sortOrder: string;
  public isActive: boolean;
  public isColumnMovedSinceTouchstart = false;

  private params: IHeaderParams;
  private elementRef: ElementRef;
  private eLabel: HTMLElement;

  public constructor(
    elementRef: ElementRef,
    private cd: ChangeDetectorRef,
  ) {
    this.elementRef = elementRef;
  }

  /* ---- Life Cycle ---- */

  public agInit(params: IHeaderParams): void {
    const columnDefinition: ColDef = params.column.getColDef();

    this.eLabel = this.elementRef.nativeElement.querySelector(
      '.ag-cell-label-container',
    );
    this.title =
      typeof columnDefinition.headerValueGetter === 'function'
        ? columnDefinition.headerValueGetter(<HeaderValueGetterParams>{})
        : columnDefinition.headerName || '';

    this.params = params;

    this.checkSortModel();

    this.params.column.addEventListener('movingChanged', () => {
      this.isColumnMovedSinceTouchstart = true;
    });

    this.params.column.addEventListener('sortChanged', () => {
      this.checkSortModel();
    });
  }

  /* ---- Public ---- */

  public onTouchStart(): void {
    this.isColumnMovedSinceTouchstart = false;
  }

  public onMouseUp(event: Event): void {
    if (this.params.enableSorting) {
      event.preventDefault();
      this.params.progressSort();
    }
  }

  public onTouchEnd(event: Event): void {
    if (!this.isColumnMovedSinceTouchstart && this.params.enableSorting) {
      event.preventDefault();
      this.params.progressSort();
    }
  }

  public refresh(): boolean {
    return false;
  }

  private checkSortModel(): void {
    const sortModel = this.params.api.getColumnState();
    const currField = this.params.column.getColDef()['field'];
    const col = sortModel.find((model: any) => model.colId === currField);

    this.sortOrder = col?.sort as string;
    this.isActive = currField === col?.colId;

    this.eLabel.classList.toggle(
      'ag-header-cell-sorted-asc',
      this.params.column.isSortAscending(),
    );
    this.eLabel.classList.toggle(
      'ag-header-cell-sorted-desc',
      this.params.column.isSortDescending(),
    );
    this.eLabel.classList.toggle(
      'ag-header-cell-sorted-none',
      this.params.column.isSortNone(),
    );

    this.cd.markForCheck();
  }
}
